import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MetaService } from 'src/services/MetaService';
import { Router } from '@angular/router';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css']
})

export class AboutUsComponent implements OnInit, OnDestroy {
  ngOnInit(): void {
    this.canonicalService.createCanonicalURL(this._router.url, "/aboutusview/");
  }

  ngOnDestroy(): void {
    this.canonicalService.removeCanonicalURL();
  }

  constructor(private _router: Router, private canonicalService: MetaService, private titleService: Title)
  {
    this.titleService.setTitle("About Us - LawShelf Educational Media");
    this.canonicalService.addMetaTags(null, "Our mission is to provide high-quality videos and articles to help people learn about the law. LawShelf is a project of National Paralegal College.", null, "About Us - Lawshelf Educational Media",null);
  }
}